import { isFunction, isObject } from "../../../../object.js";
export const getBrowserWindow = () => {
    if (isObject(window)) {
        return window;
    }
    return null;
};
export const getPerformance = () => {
    if (getBrowserWindow() && isObject(window)) {
        return window.performance;
    }
    return null;
};
export const getPerformanceObserver = () => {
    if (getBrowserWindow() && isFunction(window.PerformanceObserver)) {
        return window.PerformanceObserver;
    }
    return null;
};
export const getXMLHttpRequest = () => {
    if (getBrowserWindow() && isFunction(window.XMLHttpRequest)) {
        return window.XMLHttpRequest;
    }
    return null;
};
